import { render } from "./Home.vue?vue&type=template&id=f203e862&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=f203e862&scoped=true&lang=css"

import exportComponent from "/home/parallels/Web/Repos/mentee-mentor/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f203e862"]])

export default __exports__